// ImageSourcePicker — T22.794 (Kelly 2026-10-30, Themes > Wallpaper > Image:
// "the image for wallpaper is hard to find. Please copy wallpaper in edit
// wheel"). MEASURED live on web-stg.iyuga.net main.9bdf45e1 at 1440: the
// Themes Image tab showed only a "No image selected" tile and a grey "Choose
// image" pill (0 source tabs, 0 file inputs inline) while Edit Wheel > Design >
// Wallpaper > Image shows its source strip (Upload · Embed URL · Browse ·
// Preset · Recent), the "Reuse from your Media Library" button and the
// drag-and-drop zone right in the pane.
//
// This renders the Gallery Theme Image sources INLINE, laid out exactly like
// the Edit-Wheel Image tab (SegmentBuilder/Shared/Wallpaper/children/Image):
// the same shared `Tabs` strip with the same colours and SOURCE_STRIP_SX, the
// same universal source order (orderSourceTabs), and Media Library reuse on
// the Upload tab next to the drop zone (T22.139) instead of a tab of its own.
//
// Preset and Loops are left out on purpose: both hand back data: URIs (the SVG
// wallpaper library / animated loops), and a Gallery Theme image wallpaper
// only persists an http(s) url (galleryTheme.js sanitizeImageWallpaperRef), so
// they would be dropped on save.
import React, { useState } from "react";
import { Box } from "@mui/material";
import Tabs from "../Tabs";
import UploadMedia from "../SegmentBuilder/Shared/UploadMedia";
import MediaLibraryReuse from "../MediaLibrary/MediaLibraryReuse";
import RecentMedia from "../SegmentBuilder/Shared/RecentMedia";
import EmbedURL from "../SegmentBuilder/Shared/EmbedURL";
import MediaBrowser from "../SegmentBuilder/Shared/MediaBrowser";
import {
  orderSourceTabs,
  SOURCE_STRIP_SX,
} from "../SegmentBuilder/Shared/MediaSelection/sourceTabOrder";

export const IMAGE_SOURCES = orderSourceTabs(["Upload", "Embed URL", "Browse", "Recent"]);

export default function ImageSourcePicker({ onSelect }) {
  const [source, setSource] = useState(IMAGE_SOURCES[0]);

  const commit = (url, sourceLabel) => {
    if (!url) return;
    onSelect({ url, source: sourceLabel });
  };

  return (
    <Box data-testid="gt-image-sources">
      <Tabs
        categories={IMAGE_SOURCES}
        selectedCategory={source}
        onCategoryChange={(_, value) => setSource(value)}
        color={"#81459B"}
        indicatorColor="#C283DA"
        ariaLabel="Image source"
        sx={SOURCE_STRIP_SX}
      />
      {source === "Upload" && (
        <>
          <MediaLibraryReuse
            acceptedTypes={["image"]}
            contextLabel="Gallery Theme wallpaper"
            onInsert={(value) => commit(value?.src || value?.url, "library")}
          />
          <UploadMedia
            type="image"
            pathType="profile"
            allowGif={false}
            handleMedia={(m) => {
              if (!m.loading && m.src) commit(m.src, "upload");
            }}
          />
        </>
      )}
      {source === "Embed URL" && (
        <EmbedURL
          type="image"
          pathType="profile"
          onConfirm={(value) => {
            if (value && !value.loading) commit(value.src, "url");
          }}
        />
      )}
      {source === "Browse" && (
        <MediaBrowser
          mediaType="image"
          isGifAllowed={false}
          onConfirm={(image) => commit(image?.src || image, "browse")}
        />
      )}
      {source === "Recent" && (
        <RecentMedia
          type="image"
          showDropdown={false}
          onClickMedia={(item) => commit(item?.src || item?.url, "recent")}
        />
      )}
    </Box>
  );
}
